import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from 'src/app/base-component';
import { EventService } from 'src/app/service/event.service';
import { ValidateAndNavigateEvent, ChangeNavigationEvent, ProgressBarEvent } from 'src/app/service/events';

@Component({
    selector: 'app-criminal-record-certificate',
    templateUrl: './criminal-record-certificate.component.html',
    styleUrls: ['./criminal-record-certificate.component.scss'],
    standalone: false
})
export class CriminalRecordCertificateComponent extends BaseComponent implements OnInit {

  constructor(private _router: Router, private eventBus: EventService) {
    super(eventBus, _router);
  }

  ngOnInit(): void {
    this.sub = this.eventBus.on(
      ValidateAndNavigateEvent,
      (event): void => {
        if (event.payload.currentLink === '/criminalRecordCertificate') {
          this.eventBus.emit(new ChangeNavigationEvent({ id: event.payload.id }));
          this._router.navigateByUrl(event.payload.nextNavLink);
        }
      }
    );

    this.eventBus.emit(new ProgressBarEvent({ id: 100 }));
  }

}
